/**
 * Segment Event Handler
 * This file contains functions to handle user identification and event tracking with Segment
 */
import { sendEvent } from "./events";
// Initialize Segment identify for login
export const loginSegmentEvent = (customerid, userAttributes = {}) => {
  try {
    userAttributes.customer_id = customerid;
    sendEvent("identity", userAttributes)
  } catch (error) {
    console.log("Failed to identify user with Segment:", error);
  }
  /*try {
    if (window.analytics) {
      // Identify the user with their customer ID and attributes
      window.analytics.identify(customerid, userAttributes);
    }
  } catch (error) {
    console.log("Failed to identify user with Segment:", error);
  }*/
};

// Track logout event
export const logoutSegmentEvent = () => {
  try {
    if (window.analytics) {
      window.analytics.reset();
    }
  } catch (error) {
    console.log("Failed to logout with Segment:", error);
  }
};

// Track custom events
export const trackSegmentEvent = (eventName, properties = {}) => {
  try {
    if (window.analytics) {
      window.analytics.track(eventName, properties);
    }
  } catch (error) {
    console.log("Failed to track event with Segment:", error);
  }
};

// Set user traits/attributes
export const setUserTraits = (traits = {}) => {
  /*try {
    if (window.analytics) {
      const userId = window.analytics.user().id();
      if (userId) {
        window.analytics.identify(userId, traits);
      }
    }
  } catch (error) {
    console.log("Failed to set user traits with Segment:", error);
  }*/
  try {
    sendEvent("identity", traits)
  } catch (error) {
    console.log("Failed to set user traits with Segment:", error);
  }
};
